export const breakpoints = {
  container: '100%',

  /**
   * **Extra small screens**
   *
   * width: 22rem / 352px
   */
  xsContainer: '22rem',

  /**
   * **Small screens**
   *
   * Width: 36rem / 576px
   */
  smContainer: '36rem',

  /**
   * **Medium screens**
   *
   * Width: 48rem / 768px
   */
  mdContainer: '48rem',

  /**
   * **Large screens**
   *
   * Width: 62rem / 992px
   */
  lgContainer: '62rem',

  /**
   * **Extra large screens**
   *
   * Width: 75rem / 1200px
   */
  xlContainer: '75rem',

  /**
   * **Nothing**
   *
   * Width: 0
   */
  zero: '0',
}

export type Breakpoints = typeof breakpoints
